import { resources, unwrapListResponse } from '@/api/helpers'
import { Api } from '@/types'

export async function getTasks(): Promise<Api.Task[]> {
	return unwrapListResponse<Api.Task>(await resources.get('tasks').json())
}

export async function getTasksByProjectId(projectId: number): Promise<Api.Task[]> {
	return unwrapListResponse<Api.Task>(
		await resources.get('tasks', { searchParams: { project_id: projectId } }).json()
	)
}

export async function getEmployees(): Promise<Api.Employee[]> {
	const employees = unwrapListResponse<Api.Employee>(await resources.get('employees').json())
	return employees.map(e =>
		Object.assign(e, {
			get name(): string {
				return `${e.first_name} ${e.last_name}`
			},
		})
	)
}

export async function getEmployeeByMyoctansId(userId: number): Promise<Api.Employee> {
	return await resources.get(`employees`, { searchParams: { myoctans_id: userId } }).json()
}

export async function getProjects(): Promise<Api.Project[]> {
	const projects = unwrapListResponse<Api.Project>(await resources.get('projects').json())
	return projects.map(e =>
		Object.assign(e, {
			get name(): string {
				return `${e.number || ''}${e.number ? ' - ' : ''}${e.name}`
			},
		})
	)
}

export async function getProjectsWithTask(): Promise<Api.Project[]> {
	const projects = unwrapListResponse<Api.Project>(
		await resources.get('projects', { searchParams: { 'with-task': 1 } }).json()
	)
	return projects.map(e =>
		Object.assign(e, {
			get name(): string {
				return `${e.number || ''}${e.number ? ' - ' : ''}${e.name}`
			},
		})
	)
}

export async function getProfessions(): Promise<Api.Profession[]> {
	return unwrapListResponse<Api.Profession>(await resources.get('professions').json())
}

export async function getSuppliers(): Promise<Api.Supplier[]> {
	return unwrapListResponse<Api.Supplier>(await resources.get('suppliers').json())
}

export async function getEquipments(): Promise<Api.Equipment[]> {
	return unwrapListResponse<Api.Equipment>(await resources.get('equipment').json())
}

export async function getMaterials(): Promise<Api.Material[]> {
	return unwrapListResponse<Api.Material>(await resources.get('materials').json())
}

export async function getBonuses(): Promise<Api.Bonus[]> {
	return unwrapListResponse<Api.Bonus>(await resources.get('bonuses').json())
}

export async function getVehicles(): Promise<Api.Equipment[]> {
	return unwrapListResponse<Api.Equipment>(
		await resources.get('equipment', { searchParams: { category: 'vehicle' } }).json()
	)
}

export async function getDrills(): Promise<Api.Equipment[]> {
	return unwrapListResponse<Api.Equipment>(
		await resources.get('equipment', { searchParams: { category: 'drilling-machine' } }).json()
	)
}

export async function getSeismograph(): Promise<Api.Equipment[]> {
	return unwrapListResponse<Api.Equipment>(
		await resources.get('equipment', { searchParams: { category: 'seismograph' } }).json()
	)
}

export async function getBorers(): Promise<Api.Equipment[]> {
	return unwrapListResponse<Api.Equipment>(
		await resources.get('equipment', { searchParams: { category: 'borer' } }).json()
	)
}

export async function getStubResources(): Promise<Api.Resource[]> {
	return unwrapListResponse<Api.Resource>(await resources.get('stub').json())
}

export async function getNotifications(): Promise<Notification[]> {
	return unwrapListResponse<Notification>(await resources.get('notifications').json())
}

export async function getLocations(): Promise<Api.Location[]> {
	return unwrapListResponse<Api.Location>(await resources.get('locations').json())
}

export async function getPurchaseOrders(): Promise<Api.PurchaseOrder[]> {
	const purchaseOrders = unwrapListResponse<Api.PurchaseOrder>(
		await resources.get('purchase-orders').json()
	)
	return purchaseOrders.map(e =>
		Object.assign(e, {
			get name(): string {
				return `${e.invoice_number}`
			},
		})
	)
}

export async function getAddresses(): Promise<Api.Address[]> {
	return unwrapListResponse<Api.Address>(await resources.get('addresses').json())
}

export async function getSettings(): Promise<Api.Setting[]> {
	return unwrapListResponse<Api.Setting>(await resources.get('settings').json())
}
